export const WALLET_TYPE = {
  COSMOSTATION: 'Cosmostation',
  METAMASK: 'Metamask',
} as const;

export const Wallets = [
  {
    name: 'Metamask',
    description: 'Metamask extension wallet',
    walletType: WALLET_TYPE.METAMASK,
  },
  {
    name: 'Cosmostation',
    description: 'Cosmostation extension wallet',
    walletType: WALLET_TYPE.COSMOSTATION,
  },
];
